export default {"src":"/_next/static/media/5-year-guarantee.ed513fc6.svg","height":399,"width":561};